import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Router, { useRouter } from "next/router";
import createAccountContent from "@/translations/createAccountContent";
import {
    Box,
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
    Button,
    Text,
    useToast,
    Flex,
    Img,
} from "@chakra-ui/react";

import StarEle from "@/utils/StarElement"
import { forgotPassword } from "store/authSlice";
import { useDispatch } from "react-redux";
import useCustomToast from "hooks/useCustomToast";
const ForgotUserPassword = () => {
    const { locale } = useRouter();
    const toast = useToast();
    const toaster = useCustomToast();
    const dispatch=useDispatch();
    const {
        forgot,
        titleReset,
        resetMessage,
        email,
        cancel,
        resetButton,
    } = createAccountContent[locale];
    const { handleSubmit, register, errors } = useForm();
    const [error, setError] = useState();

    const resetPassword = async ({ email }) => {
        const resultAction = await dispatch(
            forgotPassword(email)
        );

        if (forgotPassword.fulfilled.match(resultAction)) {
            setError("");
            Router.push("/check-email");
            toast({
                title: "Check your email",
                description:
                "We will send you an email to reset your password",
                position: "top-right",
                status: "success",
                duration: 9000,
                isClosable: true,
            });
        } else {
          toaster((resultAction.payload || 'Failed!'),'error', "", true);
        }
    };

    return (
        <Flex className="forgot-pwd-main-Box-wrap">
            <Box className="container mx-auto">
                <Box className="login-page-container">
                    <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                        <Box className="login-form-wrapper">
                            <h1 className="heading-color mb-[30px] text-center">
                                {forgot}
                            </h1>
                            <Box as="form" id="reset-password">
                                <FormControl
                                    className="mb-4"
                                    isInvalid={errors.email && errors.email.message}
                                >
                                    <FormLabel className="form-label">{email}<StarEle/></FormLabel>
                                    <Input
                                        name="email"
                                        className="form-control"
                                        placeholder="Enter Email"
                                        ref={register({
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Email address is invalid"
                                            },
                                        })}
                                    />
                                    <FormErrorMessage>
                                        {errors.email && errors.email.message}
                                    </FormErrorMessage>
                                    <Text pt={2} style={{ color: "red" }} fontSize="sm">
                                        {error}
                                    </Text>
                                </FormControl>

                                <Box className="flex flex-col gap-6">
                                    <Button
                                        form={"reset-password"}
                                        onClick={handleSubmit(resetPassword)}
                                        className="dark-blue-btn mt-2"
                                    >
                                        {resetButton}
                                    </Button>
                                    <Button
                                        variant="link"
                                        textDecoration={"underline"}
                                        color={"#194172 !important"}
                                        fontWeight={"400"}
                                        className="heading-color back-to-login"
                                        onClick={() => Router.push('/login')}
                                    >
                                        Back to login
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                        <Box className="login-form-img-wrapper">
                            <Img src="/forgot-password-img.png" alt="login-img" />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Flex>
    );
};

export default ForgotUserPassword;
